// project-import
import { ThemeMode } from 'config';

export default function Theme9(colors, mode) {
  const { grey } = colors;

  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };

  const contrastText = '#fff';

  // Light Mode — Material Red Palette
  let primaryColors = [
    '#FFEBEE', // lighter
    '#FFCDD2', // 100
    '#EF9A9A', // 200
    '#E57373', // light
    '#EF5350', // 400
    '#F44336', // main
    '#E53935', // dark
    '#D32F2F', // 700
    '#C62828', // darker
    '#B71C1C'  // 900
  ];

  let errorColors = ['#FFEBEE', '#EF9A9A', '#E57373', '#D32F2F', '#B71C1C'];
  let warningColors = ['#FFF8E1', '#FFECB3', '#FFD54F', '#FFA000', '#FF6F00'];
  let infoColors = ['#E3F2FD', '#90CAF9', '#42A5F5', '#1E88E5', '#1565C0'];
  let successColors = ['#E8F5E9', '#A5D6A7', '#66BB6A', '#388E3C', '#1B5E20'];

  // Dark Mode — Deep, desaturated reds
  if (mode === ThemeMode.DARK) {
    primaryColors = [
      '#3E2723', // lighter
      '#4E342E',
      '#5D4037',
      '#6D4C41',
      '#8D6E63',
      '#EF5350', // main accent red
      '#E57373',
      '#EF9A9A',
      '#FFCDD2',
      '#FFEBEE'
    ];

    errorColors = ['#4A0C0C', '#6A1B1B', '#C62828', '#EF5350', '#FFCDD2'];
    warningColors = ['#4E342E', '#8D6E63', '#FFB300', '#FFD54F', '#FFF8E1'];
    infoColors = ['#1A237E', '#283593', '#3949AB', '#7986CB', '#E8EAF6'];
    successColors = ['#1B5E20', '#2E7D32', '#43A047', '#81C784', '#C8E6C9'];
  }

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: errorColors[0],
      light: errorColors[1],
      main: errorColors[2],
      dark: errorColors[3],
      darker: errorColors[4],
      contrastText
    },
    warning: {
      lighter: warningColors[0],
      light: warningColors[1],
      main: warningColors[2],
      dark: warningColors[3],
      darker: warningColors[4],
      contrastText: greyColors[100]
    },
    info: {
      lighter: infoColors[0],
      light: infoColors[1],
      main: infoColors[2],
      dark: infoColors[3],
      darker: infoColors[4],
      contrastText
    },
    success: {
      lighter: successColors[0],
      light: successColors[1],
      main: successColors[2],
      dark: successColors[3],
      darker: successColors[4],
      contrastText
    },
    grey: greyColors
  };
}
